var options = {
  path: '/tyc',
  title: ' 天眼测',
  icon: 'bell',
  hideSub: true,
  children: (pre => [
    { path: `${pre}media`, title: '自媒体雷达', icon: 'dot-circle-o' },
    { path: `${pre}rank`, title: '榜单排名', icon: 'dot-circle-o' },
    //{ path: `${pre}chat`, title: '社交群雷达', icon: 'dot-circle-o' },
    { path: `${pre}report`, title: '分析报告', icon: 'dot-circle-o' },
    { path: `${pre}matrix`, title: '矩阵台账', icon: 'dot-circle-o' },
    { path: `${pre}alert`, title: '违规文章提醒', icon: 'dot-circle-o' },
    { title: '模块设置',
      icon: 'wrench',
      children: [
        { path: `${pre}setting/plan`, title: '方案设置', icon: 'dot-circle-o' },
        { path: `${pre}setting/contacts`, title: '联系人设置', icon: 'dot-circle-o' },
        { path: `${pre}setting/alert`, title: '预警设置', icon: 'dot-circle-o' },
        { path: `${pre}setting/word`, title: '敏感词管理', icon: 'dot-circle-o' }
      ]
    }
    // { path: `${pre}publish`, title: '发布审核', icon: 'location-arrow' },
    // { path: `${pre}publish/history`, title: '发布记录', icon: 'history' },
    // { path: `${pre}guest-article`, title: '投稿管理', icon: 'gears' },
    // {
    //   path: `${pre}insight`,
    //   title: '选题策划',
    //   icon: 'globe',
    //   children: [
    //     { path: `${pre}insight/hot`, title: '热点事件', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/top`, title: '热点新闻', icon: 'dot-circle-o' },
    //     { path: `${pre}insight/monitor`, title: '热点方案', icon: 'dot-circle-o' }
    //   ]
    // },
    // { path: `${pre}bookmark`, title: '我的收藏', icon: 'bookmark-o' }
  ])('/tyc/')
}

export default options
